/** The saved report is plain text with **Bold:** lead lines and "- " bullets. Reads it into blocks, no HTML. */
export type ReportBlock =
  | { kind: 'heading'; text: string; rest: string }
  | { kind: 'bullet'; text: string }
  | { kind: 'para'; text: string };

const unbold = (s: string) => s.replace(/\*\*/g, '');

export function reportBlocks(text: string): ReportBlock[] {
  const blocks: ReportBlock[] = [];
  for (const raw of text.split('\n')) {
    const line = raw.trim();
    if (line === '') continue;
    const head = /^\*\*([^*]+?):?\*\*:?\s*(.*)$/.exec(line);
    if (head?.[1]) {
      blocks.push({ kind: 'heading', text: head[1].trim(), rest: unbold(head[2] ?? '').trim() });
    } else if (line.startsWith('- ')) {
      blocks.push({ kind: 'bullet', text: unbold(line.slice(2)).trim() });
    } else {
      blocks.push({ kind: 'para', text: unbold(line) });
    }
  }
  return blocks;
}
